import SetIsActive from '@/common/components/SetIsActive'
import useMutationUpdateChannel from '@/modules/manage-player/api/hooks/useMutationUpdateChannel'
import { GetChannelTableData } from '@/modules/manage-player/type'

interface IsActiveChannelProps {
	row: GetChannelTableData
}

export function IsActiveChannel({ row }: IsActiveChannelProps) {
	const { mutateAsync: updateChannel } = useMutationUpdateChannel()

	const handleMutate = async (value: boolean) => {
		await updateChannel({
			id: row.id,
			payload: {
				isActive: value,
			},
		})
	}

	return <SetIsActive defaultChecked={row.isActive} onMutate={handleMutate} />
}
